angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherDocumentsCard', function ($http, $log, $sce, EventManager, language, PlatformService, cordovaMessenger) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {
      cardTitle: '=',
      docs: '=?',
      singleDocs: '=?',
      titleAppend: '=?'
    },
    link: function (scope, element) {

      // event manager
      var eventManager = new EventManager('teacherDocumentsCard', scope);

      scope.isWebEmbed = window.isWebEmbedConnect;

      scope.getTranslation = function(id){
        return language.get(id);
      }

      scope.clickPdf = function(doc, type){
        var link = doc[type]
        $log.log(doc);
        if (PlatformService.isApp){
          cordovaMessenger.postToCordova('openPdfLink', { pdfUrl: link });
        } else {
          var new_win = window.open($sce.trustAsResourceUrl(link) ,'_blank');
          new_win.location.hash = '';
        }
        
        eventManager.broadcast("teacher:download:instructions", scope.getTranslation(doc.title)+"_" + language.getCurrentSelectedLanguage().toUpperCase());
      }
    }
  }
});
